import { PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';
import { Actions } from '../store/actions';
import { GlobalState } from '../store/reducers';
import { GO_TO_CHANGE_DOC, GO_TO_LOGOUT, GO_TO_SETUP_APP } from '../routes/paths';
import fetchMyProfile from '../api/fetchMyProfile';
import { setCurrentActiveId } from '../api/mactiveid';
import { clearLocalStorage, getMyGroupAccessId } from '../store/localstorage';

type State = {
    prescriptionId?: string;
};

interface Props extends RouteComponentProps {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
}

class InitTool extends PureComponent<Props> {
    state: State = {
        prescriptionId: undefined,
    };

    componentDidMount(): void {
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            $crisp?.push(['do', 'session:reset']);
        } catch (e) {}

        setCurrentActiveId(undefined);
        fetchMyProfile(getMyGroupAccessId())
            .then((res) => {
                if (res.loginmeta?.docid) {
                    clearLocalStorage();
                    // @deprecated move to mActiveId
                    localStorage.setItem('activeId', res.loginmeta.docid);

                    setCurrentActiveId(res.user.oid);

                    this.props.history.replace(GO_TO_SETUP_APP);
                } else {
                    this.props.history.replace(GO_TO_CHANGE_DOC);
                }
            })
            .catch((e) => {
                alert('Associated doctor profile not found. Please contact contact@eka.care');
                this.props.history.replace(GO_TO_LOGOUT);
            });
    }

    render(): ReactNode {
        return (
            <div className="flex flex-col items-center justify-center w-screen h-screen space-y-64">
                <div className="pulse">
                    <svg width="16px" height="12px">
                        <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                        <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                    </svg>
                </div>
                <p className="text-24 text-neutral-black">Setting up workspace...</p>
            </div>
        );
    }
}

export default connect()(InitTool);
